export default {
  getGameTypeWinnersForLeaderboard: state => state.gameTypeWinnersForLeaderboard,
  getGameTypeRankForLeaderboard: state => state.gameTypeRankForLeaderboard,
  getShowmodalForLevelUp: state => state.showmodalForLevelUp,
  getOpponentDetails: state => state.opponentDetails,
  getGameDescriptionDetails: state => state.gameDescriptionDetails,
  getShowHistory: state => state.showHistory,
  getGameHistoryData: state => state.gameHistoryData,
  getBundleData: state => state.bundleData,
  getThemes: state => state.themes,
  getGrandPrize: state => state.grandPrize,
  getDailyRank: state => state.dailyRank,
  getDailyPrize: state => state.dailyPrize,
  getDailyWinners: state => state.dailyWinners,
  getWeeklyRank: state => state.weeklyRank,
  getWeeklyPrize: state => state.weeklyPrize,
  getWeeklyWinners: state => state.weeklyWinners,
  getMonthlyPrize: state => state.monthlyPrize,
  getMonthlyRank: state => state.monthlyRank,
  getMonthlyWinners: state => state.monthlyWinners,
  getGrandWinners: state => state.grandWinners,
  getGrandRank: state => state.grandRank,
  getNotifications: state => state.notifications,
  getVisitorWinners: state => state.visitorWinners,
  getCarouselPrizes: state => state.carouselPrizes,
  getUserAuthorized: state => state.userAuthorized,
  totalNotifications: state => state.notifications.length,
  getBundleId: state => state.showmodalBundleId,
  getShowmodalForRanking: state => state.showmodalForRanking,
  getShowmodalForDefaultPrizeDetails: state => state.showmodalForDefaultPrizeDetails,
  getDailyRankForLeaderboard: state => state.dailyRankForLeaderboard,
  getDailyPrizeForLeaderboard: state => state.dailyPrizeForLeaderboard,
  getDailyWinnersForLeaderboard: state => state.dailyWinnersForLeaderboard,
  getWeeklyRankForLeaderboard: state => state.weeklyRankForLeaderboard,
  getWeeklyPrizeForLeaderboard: state => state.weeklyPrizeForLeaderboard,
  getWeeklyWinnersForLeaderboard: state => state.weeklyWinnersForLeaderboard,
  getMonthlyPrizeForLeaderboard: state => state.monthlyPrizeForLeaderboard,
  getMonthlyRankForLeaderboard: state => state.monthlyRankForLeaderboard,
  getMonthlyWinnersForLeaderboard: state => state.monthlyWinnersForLeaderboard,
  getGrandWinnersForLeaderboard: state => state.grandWinnersForLeaderboard,
  getGrandRankForLeaderboard: state => state.grandRankForLeaderboard,
  getGrandPrizeForLeaderboard: state => state.grandPrizeForLeaderboard,
  getAvailablePrizeTypes: state => state.availablePrizeTypes,
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/getters.js